import "core-js/modules/esnext.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "rl-row-top-30 rl-row-mobile-bottom-20"
};
const _hoisted_2 = {
  key: 0,
  class: "rl-row-bottom-calc-40 rl-row-mobile-bottom-25"
};
const _hoisted_3 = {
  class: "rl-space-left-calc-20"
};
const _hoisted_4 = {
  class: "video-detail-container rl-space-calc-40 rl-space-mobile-right-0 rl-space-mobile-left-0"
};
const _hoisted_5 = {
  class: "flex-space-between rl-row-bottom-10"
};
const _hoisted_6 = {
  class: "video-playback-panel"
};
const _hoisted_7 = {
  class: "video"
};
const _hoisted_8 = {
  class: "video-description"
};
const _hoisted_9 = {
  class: "rl-row-top-20 rl-row-mobile-top-10 rl-row-bottom-calc-50 rl-row-mobile-bottom-30"
};
const _hoisted_10 = {
  class: "rl-row-bottom-calc-50 rl-row-mobile-bottom-30"
};
const _hoisted_11 = {
  class: "rl-row-bottom-25 rl-row-mobile-bottom-10"
};
const _hoisted_12 = {
  class: "rl-row-bottom-calc-50 rl-row-mobile-bottom-30"
};
const _hoisted_13 = {
  class: "rl-row-bottom-25 rl-row-mobile-bottom-10"
};
const _hoisted_14 = {
  key: 0,
  class: "relevance"
};
const _hoisted_15 = {
  class: "rl-row-bottom-25 rl-row-mobile-bottom-20"
};
const _hoisted_16 = {
  class: "relevance-image"
};
const _hoisted_17 = {
  class: "relevance-info"
};
const _hoisted_18 = {
  class: "relevance-category rl-row-top-20"
};
const _hoisted_19 = {
  class: "relevance-bookmark"
};
const _hoisted_20 = {
  class: "relevance-time"
};
const _hoisted_21 = {
  class: "relevance-bookmark"
};
const _hoisted_22 = {
  key: 0,
  class: "rl-row-bottom-calc-40 rl-row-mobile-bottom-25"
};
const _hoisted_23 = {
  class: "video-detail-container rl-space-calc-40 rl-space-mobile-right-0 rl-space-mobile-left-0"
};
const _hoisted_24 = {
  class: "flex-space-between rl-row-bottom-10"
};
const _hoisted_25 = {
  class: "title rl-fontweight-medium rl-text-h5 rl-color-black1"
};
const _hoisted_26 = {
  key: 0,
  "xlink:href": "#bookmark_1_"
};
const _hoisted_27 = {
  key: 1,
  "xlink:href": "#bookmark-active"
};
const _hoisted_28 = {
  class: "video-playback-panel"
};
const _hoisted_29 = {
  key: 0,
  class: "video"
};
const _hoisted_30 = {
  class: "video-description"
};
const _hoisted_31 = {
  key: 0,
  class: "rl-row-bottom-calc-50 rl-row-mobile-bottom-30 rl-color-black1"
};
const _hoisted_32 = {
  class: "rl-fontweight-medium rl-text-subtitle-2 rl-row-bottom-25 rl-row-mobile-bottom-10"
};
const _hoisted_33 = ["innerHTML"];
const _hoisted_34 = {
  class: "rl-row-bottom-calc-50 rl-row-mobile-bottom-30 rl-color-black1"
};
const _hoisted_35 = {
  class: "rl-fontweight-medium rl-text-subtitle-2 rl-row-bottom-25 rl-row-mobile-bottom-10"
};
const _hoisted_36 = {
  class: "rl-fontweight-lighter rl-text-body-2"
};
const _hoisted_37 = ["innerHTML"];
const _hoisted_38 = {
  key: 0,
  style: {
    "list-style-position": "inside",
    "padding-left": "0px",
    "margin": "0px"
  }
};
const _hoisted_39 = ["onClick"];
const _hoisted_40 = {
  key: 1,
  class: "rl-row-bottom-calc-50 rl-row-mobile-bottom-30"
};
const _hoisted_41 = {
  class: "rl-text-subtitle-2 rl-fontweight-medium rl-row-bottom-25 rl-row-mobile-bottom-20"
};
const _hoisted_42 = {
  class: "resource-container"
};
const _hoisted_43 = ["href"];
const _hoisted_44 = ["href"];
const _hoisted_45 = ["href"];
const _hoisted_46 = {
  key: 2,
  class: "rl-row-bottom-calc-50 rl-row-mobile-bottom-30"
};
const _hoisted_47 = {
  class: "rl-text-subtitle-2 rl-fontweight-medium rl-row-bottom-25 rl-row-mobile-bottom-20"
};
const _hoisted_48 = {
  class: "instructors"
};
const _hoisted_49 = {
  class: "thumbnail"
};
const _hoisted_50 = ["src", "onerror"];
const _hoisted_51 = {
  class: "rl-row-bottom-15 rl-text-body-2 rl-fontweight-medium"
};
const _hoisted_52 = {
  key: 0
};
const _hoisted_53 = ["innerHTML"];
const _hoisted_54 = {
  key: 3,
  class: "relevance rl-color-black1 rl-fontweight-medium"
};
const _hoisted_55 = {
  class: "rl-text-subtitle-2 rl-fontweight-medium rl-row-bottom-25 rl-row-mobile-bottom-20"
};
const _hoisted_56 = ["onClick"];
const _hoisted_57 = {
  class: "relevance-image"
};
const _hoisted_58 = ["src"];
const _hoisted_59 = {
  class: "relevance-info"
};
const _hoisted_60 = {
  class: "rl-fontweight-medium rl-text-body-1"
};
const _hoisted_61 = {
  class: "relevance-category rl-row-top-10"
};
const _hoisted_62 = {
  class: "relevance-bookmark rl-space-mobile-right-10"
};
const _hoisted_63 = ["onClick"];
const _hoisted_64 = {
  key: 0,
  "xlink:href": "#bookmark_1_"
};
const _hoisted_65 = {
  key: 1,
  "xlink:href": "#bookmark-active"
};
const _hoisted_66 = {
  class: "rl-text-body-2 relevance-time rl-fontweight-regular"
};
const _hoisted_67 = {
  class: "relevance-bookmark"
};
const _hoisted_68 = ["onClick"];
const _hoisted_69 = {
  key: 0,
  "xlink:href": "#bookmark_1_"
};
const _hoisted_70 = {
  key: 1,
  "xlink:href": "#bookmark-active"
};
const _hoisted_71 = {
  key: 0,
  class: "rl-flex-nowrap rl-justify-content-center rl-align-items-center",
  style: {
    "height": "100%"
  }
};
const _hoisted_72 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_Breadcrumb = _resolveComponent("Breadcrumb");
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  const _component_el_skeleton = _resolveComponent("el-skeleton");
  const _directive_intersectionObserver = _resolveDirective("intersectionObserver");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_skeleton, {
    animated: "",
    loading: $setup.loading
  }, {
    template: _withCtx(() => [$setup.currentType !== $setup.videoType.skillPath.type ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "40%"
      }
    })])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_skeleton_item, {
      variant: "h1",
      style: {
        "width": "40%"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "button",
      style: {
        "width": "50px",
        "height": "50px"
      }
    })]), _cache[10] || (_cache[10] = _createElementVNode("div", {
      class: "space"
    }, null, -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_skeleton_item, {
      variant: "image",
      style: {
        "position": "absolute",
        "top": "0",
        "left": "0",
        "height": "100%",
        "width": "100%"
      }
    })])]), _renderSlot(_ctx.$slots, "playlist", {}, undefined, true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "40%"
      }
    })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "30%"
      }
    }), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "80%"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "25%"
      }
    })]), _createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "15%"
      }
    }), _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)), _createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "25%"
      }
    }), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), _createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "45%"
      }
    }), _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)), _createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "30%"
      }
    })])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "25%"
      }
    })]), _createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "15%"
      }
    }), _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)), _createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "25%"
      }
    }), _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)), _createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "45%"
      }
    }), _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)), _createVNode(_component_el_skeleton_item, {
      variant: "text",
      style: {
        "width": "30%"
      }
    })])]), $setup.currentType !== $setup.videoType.skillPath.type ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "25%"
      }
    })]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, item => {
      return _createElementVNode("div", {
        class: "relevance-item rl-row-bottom-20",
        key: item
      }, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_skeleton_item, {
        variant: "image",
        style: {
          "width": "100%",
          "height": "125px"
        }
      })]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "text",
        style: {
          "width": "50%"
        }
      })]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_skeleton_item, {
        variant: "button",
        style: {
          "width": "50px",
          "height": "50px"
        }
      })]), _createVNode(_component_el_skeleton_item, {
        variant: "text",
        style: {
          "width": "30%"
        }
      })]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_skeleton_item, {
        variant: "text",
        style: {
          "width": "10%"
        }
      })])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_skeleton_item, {
        variant: "button",
        style: {
          "width": "50px",
          "height": "50px"
        }
      })])]);
    }), 64))])) : _createCommentVNode("", true)])])]),
    default: _withCtx(() => [$setup.videoData ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [$setup.currentType !== $setup.videoType.skillPath.type ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_Breadcrumb, {
      class: "breadcrumb",
      breadcrumbData: $setup.breadcrumbData
    }, null, 8, ["breadcrumbData"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString($setup.videoData.title), 1), (_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 34 34",
      class: _normalizeClass(["bookmark", {
        active: $setup.videoData.isBookmarked
      }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => $setup.bookmarkChange(!$setup.videoData.isBookmarked, $setup.videoData.id, false), ["prevent"]))
    }, [!$setup.videoData.isBookmarked ? (_openBlock(), _createElementBlock("use", _hoisted_26)) : (_openBlock(), _createElementBlock("use", _hoisted_27))], 2))]), _cache[17] || (_cache[17] = _createElementVNode("div", {
      class: "space"
    }, null, -1)), _createElementVNode("div", _hoisted_28, [$setup.videoData.link ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[11] || (_cache[11] = [_createElementVNode("div", {
      id: "videoPlayer",
      style: {
        "position": "absolute",
        "top": "0",
        "left": "0",
        "height": "100%",
        "width": "100%"
      }
    }, null, -1)]))) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "playlist", {}, undefined, true), _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_breadcrumb, {
      separator: "|",
      class: "rl-row-top-20 rl-row-mobile-top-10 rl-text-body-2 rl-row-bottom-calc-10 rl-row-mobile-bottom-10 rl-color-black1 video-detail-breadcrumb"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.getVersion($setup.currentType, $setup.videoData)), 1)]),
        _: 1
      }), _createVNode(_component_el_breadcrumb_item, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("COMMON.LEVEL")) + " ", 1), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, i => {
          return _createElementVNode("div", {
            class: _normalizeClass(["level-indicator", {
              'active': i <= $setup.videoData.level
            }]),
            key: 'level' + i
          }, null, 2);
        }), 64))]),
        _: 1
      }), $setup.videoData.speakers && $setup.videoData.speakers.length ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: 0
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("VIDEO_DETAIL.SPEAKERS")) + ": " + _toDisplayString($setup.videoData.speakers.map(instructor => instructor.name).join(', ')), 1)]),
        _: 1
      })) : _createCommentVNode("", true), $setup.videoData.date ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: 1
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$d($setup.videoData.date, "short")) + " (PDT)", 1)]),
        _: 1
      })) : _createCommentVNode("", true), $setup.videoData.hasOwnProperty('price') ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: 2
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("COMMON.PRICE")) + ": " + _toDisplayString($setup.getPrice($setup.videoData.price)), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_breadcrumb, {
      separator: " ",
      class: "rl-text-body-2 rl-row-bottom-calc-50 rl-row-mobile-bottom-30 rl-color-black1 video-detail-breadcrumb"
    }, {
      default: _withCtx(() => [$setup.videoData.videoLanguage ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: 0
      }, {
        default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("svg", {
          viewBox: "0 0 34 34",
          class: "language-logo"
        }, [_createElementVNode("use", {
          "xlink:href": "#language"
        })], -1)), _createElementVNode("span", null, _toDisplayString($setup.languageCodeToName([$setup.videoData.videoLanguage], $setup.currentLang)), 1)]),
        _: 1
      })) : _createCommentVNode("", true), $setup.videoData.captionLanguages ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: 1
      }, {
        default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("svg", {
          viewBox: "0 0 34 34",
          class: "subtitle-logo"
        }, [_createElementVNode("use", {
          "xlink:href": "#subtitle"
        })], -1)), _createElementVNode("span", null, _toDisplayString($setup.languageCodeToName($setup.videoData.captionLanguages, $setup.currentLang)), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }), $setup.videoData.outline ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("COMMON.LIVE_DEMO_OUTLINE")), 1), _createElementVNode("div", {
      innerHTML: $setup.getOutline($setup.videoData.outline),
      class: "rl-fontweight-lighter rl-text-body-2"
    }, null, 8, _hoisted_33)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("VIDEO_DETAIL.TITLE_DESCRIPTION")), 1), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", {
      class: "rl-row-bottom-25 description",
      innerHTML: $setup.videoData.description
    }, null, 8, _hoisted_37), $setup.videoData.timecode.length ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoData.timecode, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        key: 'timecode' + index
      }, [_createElementVNode("span", {
        class: "timecode",
        onClick: $event => $setup.changeVideoTime(item.time)
      }, _toDisplayString(item.time), 9, _hoisted_39), _createTextVNode(" " + _toDisplayString(item.text), 1)]);
    }), 128))])) : _createCommentVNode("", true)])]), $setup.videoData.onlineManual || $setup.videoData.downloadFiles || $setup.videoData.tutorialArticles ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("VIDEO_DETAIL.RESOURCE")), 1), _createElementVNode("div", _hoisted_42, [$setup.videoData.onlineManual && $setup.videoData.onlineManual.length > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["resource-item", {
        'open': $setup.resourceListStatus.showOnlineManual
      }])
    }, [_createElementVNode("div", {
      class: "resource-title rl-text-body-2 rl-fontweight-medium",
      onClick: _cache[1] || (_cache[1] = $event => $setup.resourceListStatus.showOnlineManual = !$setup.resourceListStatus.showOnlineManual)
    }, [_cache[14] || (_cache[14] = _createElementVNode("div", {
      class: "arrow"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("VIDEO_DETAIL.ONLINE_MANUAL")), 1)]), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoData.onlineManual, (list, index) => {
      return _openBlock(), _createElementBlock("li", {
        class: "rl-row-bottom-10",
        key: 'Online Manual' + index
      }, [_createElementVNode("a", {
        href: list.link,
        target: "_blank"
      }, _toDisplayString(list.title), 9, _hoisted_43)]);
    }), 128))])], 2)) : _createCommentVNode("", true), $setup.videoData.tutorialArticles && $setup.videoData.tutorialArticles.length > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass(["resource-item", {
        'open': $setup.resourceListStatus.showTutorialArticles
      }])
    }, [_createElementVNode("div", {
      class: "resource-title rl-text-body-2 rl-fontweight-medium",
      onClick: _cache[2] || (_cache[2] = $event => $setup.resourceListStatus.showTutorialArticles = !$setup.resourceListStatus.showTutorialArticles)
    }, [_cache[15] || (_cache[15] = _createElementVNode("div", {
      class: "arrow"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("VIDEO_DETAIL.TUTORIAL_ARTICLES")), 1)]), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoData.tutorialArticles, (list, index) => {
      return _openBlock(), _createElementBlock("li", {
        class: "rl-row-bottom-10",
        key: 'Tutorial Articles' + index
      }, [_createElementVNode("a", {
        href: list.link,
        target: "_blank"
      }, _toDisplayString(list.title), 9, _hoisted_44)]);
    }), 128))])], 2)) : _createCommentVNode("", true), $setup.videoData.downloadFiles && $setup.videoData.downloadFiles.length > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: _normalizeClass(["resource-item", {
        'open': $setup.resourceListStatus.showDownloadFiles
      }])
    }, [_createElementVNode("div", {
      class: "resource-title rl-text-body-2 rl-fontweight-medium",
      onClick: _cache[3] || (_cache[3] = $event => $setup.resourceListStatus.showDownloadFiles = !$setup.resourceListStatus.showDownloadFiles)
    }, [_cache[16] || (_cache[16] = _createElementVNode("div", {
      class: "arrow"
    }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("VIDEO_DETAIL.DOWNLOAD_FILES")), 1)]), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoData.downloadFiles, (list, index) => {
      return _openBlock(), _createElementBlock("li", {
        class: "rl-row-bottom-10",
        key: 'Download Files' + index
      }, [_createElementVNode("a", {
        href: list.link,
        target: "_blank"
      }, _toDisplayString(list.title), 9, _hoisted_45)]);
    }), 128))])], 2)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $setup.videoData.speakers && $setup.videoData.speakers.length ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("VIDEO_DETAIL.INSTRUCTOR")), 1), _createElementVNode("div", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoData.speakers, (instructor, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "instructor-info",
        key: instructor.name + index
      }, [_createElementVNode("div", _hoisted_49, [_createElementVNode("img", {
        src: instructor.thumbnail,
        onerror: $setup.handleThumbnailError
      }, null, 8, _hoisted_50)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_51, [_createTextVNode(_toDisplayString(instructor.name) + " ", 1), instructor.type === $setup.SpeakerTypeEnum.GUEST && instructor.title ? (_openBlock(), _createElementBlock("span", _hoisted_52, "  - " + _toDisplayString(instructor.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
        innerHTML: $setup.textToHtml(instructor.description),
        class: "rl-fontweight-lighter rl-text-body-2"
      }, null, 8, _hoisted_53)])]);
    }), 128))])])) : _createCommentVNode("", true), $setup.currentType !== $setup.videoType.skillPath.type && $setup.videoData.relevance && $setup.videoData.relevance.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("VIDEO_DETAIL.TITLE_RELEVANCE")), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoData.relevance, (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "relevance-item rl-row-bottom-20",
        key: item.id,
        onClick: $event => $setup.clickImage(item, index)
      }, [_createElementVNode("div", _hoisted_57, [_createElementVNode("img", {
        src: item.thumbnail,
        class: "rl-img-response",
        alt: ""
      }, null, 8, _hoisted_58)]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [(_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 34 34",
        class: _normalizeClass(["bookmark", {
          active: item.isBookmarked
        }]),
        onClick: _withModifiers($event => $setup.bookmarkChange(!item.isBookmarked, item.id, true), ["prevent", "stop"])
      }, [!item.isBookmarked ? (_openBlock(), _createElementBlock("use", _hoisted_64)) : (_openBlock(), _createElementBlock("use", _hoisted_65))], 10, _hoisted_63))]), _createVNode(_component_el_breadcrumb, {
        separator: "|",
        class: "rl-text-body-3 rl-color-gray2"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("VIDEO_DETAIL.TUTORIAL")), 1)]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("COMMON.LEVEL")) + " ", 1), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, i => {
            return _createElementVNode("div", {
              class: _normalizeClass(["level-indicator", {
                'active': i <= item.level
              }]),
              key: 'level' + i
            }, null, 2);
          }), 64))]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1024)]), _createElementVNode("div", _hoisted_66, _toDisplayString($setup.getVideoTime(item.videoLength)), 1)]), _createElementVNode("div", _hoisted_67, [(_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 34 34",
        class: _normalizeClass(["bookmark", {
          active: item.isBookmarked
        }]),
        onClick: _withModifiers($event => $setup.bookmarkChange(!item.isBookmarked, item.id, true), ["prevent", "stop"])
      }, [!item.isBookmarked ? (_openBlock(), _createElementBlock("use", _hoisted_69)) : (_openBlock(), _createElementBlock("use", _hoisted_70))], 10, _hoisted_68))])], 8, _hoisted_56)), [[_directive_intersectionObserver, () => $setup.recordProductImpression(item, $setup.videoType[$setup.currentType].category + '-relevance', index)]]);
    }), 128))])) : _createCommentVNode("", true)])])], 64)) : _createCommentVNode("", true)]),
    _: 3
  }, 8, ["loading"])]), $setup.isApiError ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_createElementVNode("div", {
    innerHTML: _ctx.$t('COMMON.API_ERROR_TITLE') + _ctx.$t('COMMON.API_ERROR_DESCRIPTION')
  }, null, 8, _hoisted_72)])) : _createCommentVNode("", true)], 64);
}